/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:50
**/

import { NgModule, LOCALE_ID } from "@angular/core";
import { CommonModule, registerLocaleData } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { IonicStorageModule } from "@ionic/storage";

import { TranslateModule, TranslateLoader,TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { FormsModule, ReactiveFormsModule} from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HttpClient } from "@angular/common/http";

import { DirectivesModule } from "./../../directives/directives.module";
import { PipesModule } from "./../../pipes/pipes.module";
import { ComponentsModule } from "./../../components/components.module";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { ElMonteSagradoGlPageRoutingModule } from "./el-monte-sagrado-gl-routing.module";
import { environment } from "./../../../../src/environments/environment";
import { Globals } from "../../class/globals/globals";
import { TranslateConfiguration } from "../../class/translate-configuration/translate-configuration";
import { PopoverController } from "@ionic/angular";
import { PopoverComponent } from "../../components/popover/popover.component";
import { ElMonteSagradoGlPage } from "./el-monte-sagrado-gl.page";


/** i18n **/
import localeEnGb from "@angular/common/locales/en-GB";
registerLocaleData(localeEnGb, "en-GB");
import localeEs from "@angular/common/locales/es";
registerLocaleData(localeEs, "es");
import localeGl from "@angular/common/locales/gl";
registerLocaleData(localeGl, "gl");

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}



@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		HttpClientModule,
		DirectivesModule,
		PipesModule,
		ComponentsModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			}
		}),
		IonicStorageModule.forRoot({ name : "Boqueixon"  }),
		ElMonteSagradoGlPageRoutingModule
	],
	declarations: [ElMonteSagradoGlPage],
	exports: [],
	entryComponents: [],
	providers: [
	
			
			{
				provide: LOCALE_ID,
				deps: [TranslateConfiguration],
				useFactory: (TranslateConfiguration: {
					locale: string;
				})=>TranslateConfiguration.locale
			}
,
			StatusBar,
			PopoverController,
			Globals,
			TranslateConfiguration
	]
})
export class ElMonteSagradoGlPageModule {}
